export const SELECTOR_FLYOUT_CHROME_CLASS =
  'border-outline-default bg-raised/95 shadow-card rounded-2xl border p-2 backdrop-blur-md';

export const SELECTOR_OPTION_CLASS =
  'text-glyph-primary duration-fast flex min-h-11 cursor-pointer items-center justify-between gap-3 rounded-xl px-4 py-2.5 text-sm transition-colors';

export function getSelectorOptionStateClass({
  selected,
  highlighted = false,
}: {
  selected: boolean;
  highlighted?: boolean;
}) {
  if (selected) return 'bg-surface-tertiary font-medium';
  if (highlighted) return 'bg-surface-tertiary/50';
  return 'hover:bg-surface-tertiary/50';
}
